export const isFoodlesSaturdayOffer = () => {
  const now = new Date();
  const day = now.getDay(); // 6 is Saturday
  const hours = now.getHours();
  
  // Check if it's Saturday (6) and between 11:00 (11) and 22:00 (22)
  return day === 6 && hours >= 10 && hours < 22;
};

export const calculateDiscount = (price) => {
  if (!isFoodlesSaturdayOffer()) return price;
  const discount = 0.10; // 10% discount
  return price - (price * discount);
};
